module.exports = __webpack_public_path__ + "media/brands/Vendors_Dynamic_Products_3-2621c97c.jpg";